export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40833c4049450e71212bfbdc116177f6bca99e300a&name=addToFolderEventAction!'